export default __webpack_public_path__ + "media/zurb/img/contact/contact2-e16a86a6f8568635d9c842781bbc948a.png";